export default __webpack_public_path__ + "static/ign-7299ac9c45530481368daae5be84f423.jpeg";